import $axios from '~/plugins/axios';
import i18next from 'i18next';

import { Api, GetReleaseNotesParams, PaginatorResult, ReleaseNote } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { createDict, DEFAULT_RELEASE_NOTE_LOCALE, Dict, getReleaseNoteLocale } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'releaseNotesPage',
			pageSizeQueryKey: 'releaseNotesPerPage',
			itemCountGetter: 'releaseNotes/list/totalCount',
		}),
	})
	.withState({
		storedReleaseNotes: {} as Dict<ReleaseNote>,
		releaseNotes: [] as ReleaseNote[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byName: state => (releaseNoteName: number) => (
			state.storedReleaseNotes[releaseNoteName] ?? null
		),
		page: state => state.releaseNotes,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_RELEASE_NOTES (state, releaseNotes: ReleaseNote[]) {
			state.storedReleaseNotes = {
				...state.storedReleaseNotes,
				...createDict(releaseNotes, (note) => note.name),
			};
		},
		SET_RELEASE_NOTES (state, releaseNoteNames: string[]) {
			state.releaseNotes = releaseNoteNames.map(name => state.storedReleaseNotes[name]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetReleaseNotesParams = {}) {
			const locale = getReleaseNoteLocale(i18next.language) ?? DEFAULT_RELEASE_NOTE_LOCALE;

			commit('SET_LOADING', true);
			const { data } = await api.get('/release-notes', {
				params: {
					...params,
					type: 'web',
					locale: locale,
				},
			});
			commit('SET_LOADING', false);

			const releaseNotes = data.payload;
			const releaseNoteNames = releaseNotes.map(note => note.name);

			commit('SET_STORED_RELEASE_NOTES', releaseNotes);
			commit('SET_RELEASE_NOTES', releaseNoteNames);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
